<template>
  <div>
    <navigation></navigation>
    <div class="m-4">
      <div v-if="header" class="h5 text-primary pb-1 mb-3 border-bottom">
        <slot name="header">
          <span class="font-weight-bold">
            <font-awesome-icon v-if="icon" :icon="icon" class="mr-2"/>
            {{ header }}
          </span>
        </slot>
      </div>
      <div>
        <slot name="main"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from '@/components/Navigation'
import {getIcon} from "@/utils/business-objects";

export default {
  props: {
    header: String,
    type: String
  },
  components: {
    navigation
  },
  computed: {
    icon() {
      return getIcon(this.type)
    }
  }
}
</script>
